import React from 'react';

function LogoPage() {
  return (
    <img src={process.env.PUBLIC_URL + '/favicon.ico'} alt="BrogVerse Logo" />
  );
}

export default LogoPage;
